export const defaultEventGroupProps = {
    min: 0,
    max: 0
}